import { useState } from 'react';
import PropTypes from 'prop-types';
import { appAssets } from 'constants/assets';
import { ExportToImageValues } from '../../../constants/exportToImage';
import { BsFiletypePng } from 'react-icons/bs';
import { SiJpeg } from 'react-icons/si';
import Tooltip from 'components/DynamicTable/DynamicTableTooltip';
import './exporttoimageoptions.css';

interface ExportToImageProps {
  onHandleCapture: (
    id: string | undefined,
    name: string | undefined,
    isJpeg: boolean
  ) => Promise<void>;
  id?: string;
  widgetName?: string;
}

const ExportToImage: React.FC<ExportToImageProps> = ({ onHandleCapture, id, widgetName }) => {
  const ImageIcon = appAssets.icons.IMAGE_ICON;

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const exportToImage = (isJpeg = false) => {
    toggleMenu();

    setTimeout(() => {
      onHandleCapture(id, widgetName, isJpeg);
    }, 0);
  };

  return (
    <div className="meatball-export-menu">
      <div className="meatball-export-icon" onClick={toggleMenu}>
        <ImageIcon style={{ color: '#00a0af' }} />
      </div>
      {isOpen && (
        <div className="menu-export-options">
          <ul>
            {BsFiletypePng ? (
              <Tooltip
                placement={'left'}
                hideBrowserTooltip={true}
                text={ExportToImageValues.pngText}
              >
                <li onClick={() => exportToImage()}>
                  <BsFiletypePng size={ExportToImageValues.iconSize} />
                </li>
              </Tooltip>
            ) : null}
            {SiJpeg ? (
              <Tooltip
                placement={'left'}
                hideBrowserTooltip={true}
                text={ExportToImageValues.jpegText}
              >
                <li onClick={() => exportToImage(true)}>
                  <SiJpeg size={ExportToImageValues.iconSize} />
                </li>
              </Tooltip>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
};

ExportToImage.propTypes = {
  onHandleCapture: PropTypes.any,
  id: PropTypes.any,
  widgetName: PropTypes.any,
};

export default ExportToImage;
